import { CoveoSearchResult as SearchResult } from "@dcl-ue/coveo-search";
var CoveoSearchResult = SearchResult.template;
CoveoSearchResult.displayName = "CoveoSearchResult";
export default CoveoSearchResult;